import React from "react";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";
import { DateTime } from "luxon";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import AppModal from "../../../Components/Models/app-modal";
import { Form, Button } from "react-bootstrap";
import api from "../../../Services/Api/api";

const SCREEN_NAME = "EDIT_EXPENSE_SCREEN";

class EditExpenseInner extends AppComponent {
  state = {
    label: this.props.expense?.label || "",
    note: this.props.expense?.note || "",
    amount: this.props.expense?.amount || "",
    //2022-06-22T18:03
    t: (this.props.expense?.t
      ? DateTime.fromJSDate(new Date(this.props.expense.t))
      : DateTime.now()
    ).toFormat("yyyy-LL-dd'T'HH:mm"),
  };

  formRef = React.createRef(null);

  async onSubmit() {
    try {
      if (this.state.loading) return;
      const isValid = this.formRef?.current?.reportValidity();
      if (!isValid) return;

      this.setAsyncState({ loading: true, error: null });
      const payload = _.pick(this.state, ["label", "note", "amount", "t"]);

      let res = null;
      if (this.props.expense?._id) {
        res = await api.patch(`v1/expense/${this.props.expense._id}`, payload);
      } else {
        res = await api.post("v1/expense", payload);
      }

      this.setAsyncState({ loading: false });
      this.props.onSubmit(res);
    } catch (e) {
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  renderForm() {
    const {
      props: { renderModal = false },
      state: { loading, error, label, note, amount, t },
    } = this;

    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          this.onSubmit();
        }}
        ref={this.formRef}
      >
        <Form.Group className="mb-3">
          <Form.Label>Label</Form.Label>
          <Form.Control
            type="text"
            placeholder="Label"
            value={label}
            onChange={(e) => this.setAsyncState({ label: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type="number"
            placeholder="Amount"
            value={amount}
            onChange={(e) => this.setAsyncState({ amount: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Time</Form.Label>
          <Form.Control
            type="datetime-local"
            value={t}
            onChange={(e) => this.setAsyncState({ t: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Note</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Note"
            value={note}
            onChange={(e) => this.setAsyncState({ note: e.target.value })}
          />
        </Form.Group>

        <div className="errormsg">{error}</div>

        {renderModal ? null : (
          <Button variant="primary" type="submit" disabled={loading}>
            Submit
          </Button>
        )}
      </Form>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: this.props.expense?._id ? "Edit Expense" : "Add New Expense",
          onSubmit: this.onSubmit.bind(this),
          disableSubmit: this.state.loading,
        }}
      >
        {this.renderForm()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderForm();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const EditExpense = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditExpenseInner);

export default EditExpense;
